import { apiInstance } from '.';
import { AxiosRequestConfig } from 'axios';

export const apiPOST = async (
  url: string,
  data: any,
  config?: AxiosRequestConfig
): Promise<any> => {
  const response: any = await apiInstance
    .post(url, data, config)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.log(error);
      // Request made and server responded
      if (error.response) {
        if (error.response.data) {
          return error.response.data;
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        return 'Error ' + error.message;
      }
    });
  return response;
};
